module.exports = __webpack_public_path__ + "img/auburn-opelika-logo.0e094307.jpg";